<template>
  <div class="content">
    <van-sticky class="topMenu">

      <headerNav leftNav=" " :title="navTitle" @leftClick="back"></headerNav>
    </van-sticky>

    <main class="content-main">
      <!-- 步骤条 -->
      <TaskProgress
        :subAndSup="{ supTask: taskPlanObj.superiorsTask, supRate: Number(taskPlanObj.superiorsAccomplishRate), subTask: taskPlanObj.subordinateTask, subRate: Number(taskPlanObj.subordinateTaskAccomplishRate) }"
        :isProgress="false" :percentageMoney="taskPlanObj.practicalAccomplish"
        :unit="routerData.termSlug == 'transfer_output' || routerData.termSlug == 'supply_output' ? '万' : '个'" />

      <!-- 转单详情 -->
      <div class="content-center-title">
        <div class="left-line"></div>
        <div>{{ routerData.name ? routerData.name + '详情' : '详情' }}</div>
      </div>

      <!-- table -->
      <el-table :data="userTableData" header-cell-class-name="market-title" row-class-name="market-row" row-key="userId"
        :expand-row-keys="defaultExpandList" :highlight-current-row="false">
        <!-- 自定义暂无数据 -->
        <template slot="empty">
          <div class="empty-no-data">
            <img src="../../../../assets/task-management/no-data.png" alt="">
            <div>暂无数据</div>
          </div>
        </template>
        <el-table-column type="index" label="TOP" align="center" width="40">
          <template slot-scope="props">
            <div v-if="props.$index < 3" style="line-height: 1;"><img class="index-img" :src="getImageIndex(props.$index)"
                alt=""></div>
            <div v-else> {{ props.$index + 1 }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="userName" label="人员" min-width="55" show-overflow-tooltip>
          <template slot-scope="props">
            <div class="anomaly">
              <span class="market-content-a" @click="onClickPersonnelDetails(props.row)">
                {{ props.row.userName }}
              </span>
              <div class="anomaly-bg" v-if="props.row.isSpecial && props.row.isSpecial == '0'">异常</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="transferProductionValue" :label="outputCount.transferProductionValue" align="right"
          min-width="85">
        </el-table-column>
        <el-table-column prop="taskProductionValue" :label="outputCount.taskProductionValue" align="right" min-width="85">
        </el-table-column>
        <el-table-column prop="accomplishRate" label="完成率" align="right" min-width="69">
          <template slot-scope="scope">
            <span v-if="scope.row.accomplishRate">{{ scope.row.accomplishRate && scope.row.accomplishRate != '-' ?
              scope.row.accomplishRate + '%' : scope.row.accomplishRate
            }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="handle" label="操作" min-width="38">
          <template slot-scope="scope">
            <span class="market-details" @click="expandControlRow(scope.row)">详情</span>
          </template>
        </el-table-column>
        <!-- 展开行详情 -->
        <el-table-column type="expand" width="1">
          <template slot-scope="scope">
            <div class="market-content-expand">
              <div class="market-content-expand-left">
                <img src="@/assets/task-management/task-details-table-expand.png" alt="">
                <div>上月任务：{{ scope.row.lastMonthProductionValue }}{{ routerData.termSlug == 'transfer_output' ||
                  routerData.termSlug == 'supply_output' ? '万元' : '个' }}</div>
              </div>
              <div class="market-content-expand-right">
                <span class="color-green" v-if="scope.row.isSuccess == '1'">已完成</span>
                <span class="color-red" v-else>未完成</span>
              </div>
            </div>
            <div class="market-content-expand-row"
              v-if="(scope.row.taskProductionValue == '-' || scope.row.taskProductionValue == '0' || scope.row.taskProductionValue == '0.00') && setTaskRole && Number(taskPlanObj.subordinateTask || 0) && scope.row.isSpecial != '0'">
              <div class="market-content-expand-seting" @click="setTask(scope.row)">
                <img src="@/assets/task-management/task-details-table-seting.png" alt="">
                <div>任务设置</div>
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </main>

    <!-- 任务设置 -->
    <van-dialog v-model="setTaskDialogVisible" :showConfirmButton="false" @close="setTaskDialogClose">
      <div class="set-task-dialog">
        <!-- 导航 -->
        <div class="set-task-dialog-nav">
          任务设置
          <div class="set-task-dialog-nav-close" @click="closeSetTaskDialog">×</div>
        </div>
        <!--内容  -->
        <div class="set-task-dialog-mian">
          <van-form @submit="onSubmitTask" :key="fromRestFields">
            <van-field v-model="taskDialogFrom.value" label-width="80px" label="任务产值:" placeholder="请输入任务产值"
              :rules="[{ required: true }]" type="digit">
              <i slot="left-icon" style="color:red">*</i>
              <template #button>{{ routerData.termSlug == 'transfer_output' ||
                routerData.termSlug == 'supply_output' ? '万' : '个' }}</template>
            </van-field>
            <div class="set-task-dialog-foot">
              <van-button class="btn" round block type="info" native-type="submit">确认</van-button>
            </div>
          </van-form>

        </div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import TaskProgress from "@/components/task-management/task-progress.vue"
import estimateOutput from "../../component/data.js"
import api from "@/api/task-management/board.js";
import { Toast } from "vant";

export default {
  components: {
    TaskProgress
  },
  data () {
    return {
      // 任务看板路由接参
      routerData: {},
      // 转单表格数据
      userTableData: [],
      // 展开行id--转单
      defaultExpandList: [],
      // 任务设置弹窗
      setTaskDialogVisible: false,
      taskDialogFrom: {
        value: ''
      },
      // 清空form校验
      fromRestFields: 0,
      // 表头动态展示内容
      outputCount: {},
      // 判读任务设置是否有权限
      setTaskRole: false,
      // 顶部任务产值目标
      taskPlanObj: {},
      // 任务设置当前行数据
      setRowsData: {}
    }
  },
  created () {
    let localData = JSON.parse(localStorage.getItem('TABLE_HEADER_CONTENT'))
    let userData = JSON.parse(localStorage.getItem('USER_DATA'))
    this.routerData = { ...localData, ...userData }
    if (this.routerData.roleCode == 'ROLE_113490' || this.routerData.roleCode == 'ROLE_327530' || this.routerData.roleCode == 'ROLE_553504' || this.routerData.roleCode == 'ROLE_670920') {
      this.setTaskRole = true
    } else {
      this.setTaskRole = false
    }
    this.getTableData()
    this.outputCount = estimateOutput(localData.termSlug)
    this.navTitle = this.outputCount.transferProductionValue.slice(0, 4) + '详情'
  },
  methods: {
    back () {
      this.$router.go(-1)
    },
    // 查询表格数据
    async getTableData () {
      try {
        Toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        const { data } = await api.taskDetailApi({ ext: this.routerData.termSlug, Q_reportData_EQ: this.routerData.Q_reportData_EQ, type: '3', marketCode: this.routerData.marketCode, departmentName: this.routerData.departmentName, departmentId: this.routerData.departmentId })
        this.taskPlanObj = data.accomplishCondition ? data.accomplishCondition : {}
        this.userTableData = data.data01
      } finally {
        Toast.clear()
      }
    },
    // 控制展开行--转单
    expandControlRow (item) {
      const position = this.defaultExpandList.indexOf(item.userId)
      if (position !== -1) {
        this.defaultExpandList.splice(position, 1)
      } else {
        this.defaultExpandList.push(item.userId)
      }
    },
    // 获取图片
    getImageIndex (index) {
      return require(`@/assets/task-management/task-details-table-${index + 1}.png`)
    },
    // 任务设置
    setTask (row) {
      this.setRowsData = row
      this.setTaskDialogVisible = true
    },
    // 确定
    async onSubmitTask () {
      try {
        let obj = {
          id: this.taskPlanObj.taskParentId,
          taskDate: this.routerData.Q_reportData_EQ,
          roleCode: this.routerData.roleCode,
          termId: this.routerData.termSlug,
          multiTerm: JSON.stringify({ [this.setRowsData.userId]: this.taskDialogFrom.value })
        }
        const data = await api.setTasksApi(obj)
        if (data.code == 200) {
          this.getTableData()
          Toast('设置成功')
        }
      } finally {
        this.setTaskDialogVisible = false
      }

    },
    // 关闭
    closeSetTaskDialog () {
      this.setTaskDialogVisible = false
    },
    setTaskDialogClose () {
      this.fromRestFields++
      this.taskDialogFrom = {
        value: ''
      }
    },
    // 点击人员查看人员详情
    onClickPersonnelDetails (row) {
      this.$router.push({ path: '/task-management/board/employee-single', query: { item: JSON.stringify(row) } })
    }
  },
}
</script>

<style lang="scss" scoped>
.content ::v-deep {
  .el-table__expand-icon>.el-icon {
    display: none;
  }

  .empty-no-data {
    img {
      width: 160px;
      height: 150px;
    }

    div {
      color: #5E5E5E;
      font-size: 18px;
      margin-top: -40px;
    }
  }

  .content-main {
    background: #F5F5F5;
    height: calc(100vh - 50px);
    overflow: auto;
    margin-top: -1px;

    .table-content {
      height: calc(100vh - 315px);
      overflow: auto;
    }

    .content-center-title {
      height: 47px;
      line-height: 47px;
      display: flex;
      align-items: center;
      background: #fff;
      padding: 0px 10px;
      margin-top: 16px;

      .left-line {
        width: 4px;
        height: 18px;
        background: #0E8BFF;
        margin-right: 8px;
      }

      div {
        color: #333333;
        font-size: 18px;
        font-family: PingFang SC-Bold, PingFang SC;
        font-weight: 550;
      }
    }

    .market-title {
      background-color: #F5F5F5;
      color: #1D2129;
      font-size: 18px;
      font-family: PingFang SC-Bold, PingFang SC;
      padding: 0px 0px;

      .cell {
        padding: 10px 3px;
        font-size: 13px;
        font-weight: 500;

      }
    }

    .el-table__body-wrapper {
      height: calc(100vh - 150px);
      overflow: auto;
    }


    .market-row {
      font-size: 16px;
      color: #1D2129;
      overflow: visible;

      .el-table__cell {
        padding: 3px 0px;
        height: 30px;
        overflow: visible;
      }

      .cell {
        padding: 5px 3px;
        font-weight: 400;
        overflow: visible;
        white-space: nowrap;

        .anomaly {
          .market-content-a {
            white-space: nowrap;
            // /* 不换行 */
            overflow: hidden;
            // /* 隐藏超出部分 */
            text-overflow: ellipsis;
            display: block;
          }

        }

      }
    }

    .el-table__expand-colum {
      visibility: hidden;
    }

    .market-details {
      color: #0E8BFF;
      font-size: 13px;
    }

    .market-content-a {
      color: #0E8BFF;
      font-size: 13px;
      font-weight: 400;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      display: block;
    }

    .anomaly {
      position: relative;

      .anomaly-bg {
        height: 19px;
        width: 39px;
        text-align: center;
        color: #fff;
        position: absolute;
        font-size: 16px;
        top: -8px;
        right: -25px;
        line-height: 19px;
        background: url('../../../../assets/task-management/employee-list-anomaly.png') no-repeat;
        background-position: 100%;
        background-size: cover;
        z-index: 10;
      }
    }

    .index-img {
      width: 20px;
      height: 20px;
    }

    .market-content-expand {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 12px 11px 16px;
      // border-bottom: 1px solid #F1F1F1;

      .market-content-expand-left {
        display: flex;
        align-items: center;

        img {
          width: 20px;
          height: 20px;
        }

        div {
          color: #545454;
          font-size: 15px;
          margin-left: 10px;
        }
      }

      .market-content-expand-right {
        width: 46px;
        height: 22px;
        line-height: 22px;
        font-size: 13px;
        text-align: center;
        font-weight: bold;
        font-family: PingFang SC-Bold, PingFang SC;

        span {
          padding: 2px 3px;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: visible;
          font-weight: 500;
          border-radius: 4px;
        }

        .color-red {
          color: #FF6157;
          background: #FAEBEA;
        }

        .color-green {
          color: #17CA5E;
          background: #E3F5EA;
        }
      }
    }

    .market-content-expand-row {
      display: flex;
      justify-content: end;
      margin: 0px 11px 4px;
      padding-top: 12px;
      border-top: 1px solid #F1F1F1;

      .market-content-expand-seting {
        display: flex;
        align-items: center;
        width: 91px;
        height: 28px;
        line-height: 28px;
        border: 1px solid #3DA2FF;
        color: #0E8BFF;
        font-size: 18px;
        border-radius: 4px;
        padding-left: 6px;
        box-sizing: border-box;
        cursor: pointer;
        user-select: none;

        img {
          width: 18px;
          height: 18px;
          margin: 1px 2px 0px 0;
        }
      }
    }


  }

  .set-task-dialog {
    .set-task-dialog-nav {
      text-align: center;
      margin: 12px 0px;
      padding: 0 17px 12px 17px;
      font-weight: bold;
      color: #424242;
      font-size: 16px;
      border-bottom: 1px solid #DFDFDF;

      .set-task-dialog-nav-close {
        float: right;
        font-size: 15px;
      }
    }

    .set-task-dialog-mian {
      padding: 16px 0 0;

      .van-field__body {
        border-bottom: 1px solid #BEBEBE;
      }

      .van-field__label {
        margin-right: 0;
        color: #252523;
        font-size: 16px;
      }

      .van-cell::after {
        border: 0;
      }

      .set-task-dialog-foot {
        // width: 100%;
        text-align: center;
        padding: 0px 14px 18px 15px;
        margin-top: 16px;

        .btn {
          border-radius: 4px;
          // width: 290px;
          // height: 44px;
          background: #3975C6;
        }
      }

    }

  }

}
</style>